import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { responseError } from '@/utils/errors';
import { activeRequestReceiptState, findWorkspaceForm, showWorkspaceFormState } from './state';
import { workspaceFormActions } from '../constants';

const fetchWorkspaceForm = withDraft((draft, { category, code }) => {
  const item = findWorkspaceForm(draft, { category, code });
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showWorkspaceFormHealthError = withDraft((draft, { code }) => {
  draft.forms.health[code].readStatus = states.ERROR;
});

const showWorkspaceFormHealthSuccess = withDraft((draft, { code }) => {
  draft.forms.health[code].readStatus = states.SUCCESS;
  draft.forms.health[code].readErrors = [];
});

const showWorkspaceRequestReceipt = withDraft((draft, { name, text }) => {
  draft.activeRequestReceipt = activeRequestReceiptState(true, name, text);
});

const hideWorkspaceRequestReceipt = withDraft((draft) => {
  draft.activeRequestReceipt = activeRequestReceiptState();
});

const showWorkspaceForm = withDraft((draft, action) => showWorkspaceFormState(draft, action));

const showWorkspaceFormError = withDraft((draft, action) => {
  const item = findWorkspaceForm(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default {
  [workspaceFormActions.FETCH_WORKSPACE_FORM]: fetchWorkspaceForm,
  [workspaceFormActions.HIDE_WORKSPACE_REQUEST_RECEIPT]: hideWorkspaceRequestReceipt,
  [workspaceFormActions.SHOW_WORKSPACE_FORM]: showWorkspaceForm,
  [workspaceFormActions.SHOW_WORKSPACE_FORM_ERROR]: showWorkspaceFormError,
  [workspaceFormActions.SHOW_WORKSPACE_FORM_HEALTH_ERROR]: showWorkspaceFormHealthError,
  [workspaceFormActions.SHOW_WORKSPACE_FORM_HEALTH_SUCCESS]: showWorkspaceFormHealthSuccess,
  [workspaceFormActions.SHOW_WORKSPACE_REQUEST_RECEIPT]: showWorkspaceRequestReceipt,
};
